import type { StoreSearchSort } from "../utils/storeSearchSort";
import { useTranslation } from "../context/LanguageContext";

const SORT_LABELS: Record<StoreSearchSort, string> = {
  best_deal: "products.storeSortBestDeal",
  most_on_hand: "products.storeSortMostOnHand",
  closest: "products.storeSortClosest",
};

interface StoreSearchSortControlsProps {
  value: StoreSearchSort;
  onChange: (sort: StoreSearchSort) => void;
  className?: string;
  bestDealLabel?: string;
}

export default function StoreSearchSortControls({
  value,
  onChange,
  className = "",
  bestDealLabel,
}: StoreSearchSortControlsProps) {
  const { t } = useTranslation();

  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`}>
      {(Object.keys(SORT_LABELS) as StoreSearchSort[]).map((sort) => {
        const active = value === sort;
        return (
          <button
            key={sort}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(sort)}
            className={`rounded-full px-2.5 py-1 text-[10px] font-semibold transition-colors ${
              active
                ? "bg-gray-900 text-white dark:bg-white dark:text-gray-900"
                : "bg-gray-100 text-gray-600 hover:bg-gray-200 dark:bg-dark-700 dark:text-dark-200 dark:hover:bg-dark-600"
            }`}
          >
            {sort === "best_deal" && bestDealLabel ? bestDealLabel : t(SORT_LABELS[sort])}
          </button>
        );
      })}
    </div>
  );
}
